<template>
  <div class="home">
    <div class="heading">
      <h1>{{ $t("title") }}</h1>
      <h2>by&nbsp;<complex-earth-logo /></h2>
    </div>
    <section class="text">
      <section class="lead">
        {{ $t("home.lead") }}
      </section>
      <section class="body" v-html="$t('home.body')"></section>
    </section>
    <!-- <router-link class="home-link-patches button" to="patches">
      <i class="fas fa-search" /> {{ $t("routes.patches") }}
    </router-link> -->
  </div>
</template>
<script>
import ComplexEarthLogo from "@/components/ComplexEarthLogo";

export default {
  components: { ComplexEarthLogo },
};
</script>

<style lang="scss">
//noinspection CssReplaceWithShorthandSafely
body.page--home {
  background: black;
  --background: url("../assets/bg-dark.jpg");

  main {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .parent-link a {
    color: white;
  }
}

.home {
  width: 100%;
  color: white;
  text-shadow: 1px 1px 2px black;
}

.heading {
  h1 {
    margin-bottom: 0.2em;
  }

  h2 {
    margin: 0;
  }

  img {
    filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 1));
  }
}

.text {
  margin: 3rem 0;

  .lead {
    font-size: 24px;
  }

  .body {
    font-size: 16px;
  }
}

@media screen and (min-width: 600px) {
  .home-link-patches {
    font-size: 24px;
  }
}

@media screen and (max-width: 600px) {
  .body {
    text-align: justify;
  }

  .text {
    margin: 0;
  }

  .heading {
    margin: 2rem 0;
  }

  .complex-earth-logo {
    height: 20px;
  }

  .home-link-patches {
    display: block;
    text-align: center;
    margin: 2rem 0;
  }
}
</style>
